import {Link, useLocation} from "react-router-dom";
import React, {useMemo, useState} from "react";
import {replaceEmptyStringsOnNull} from "../../../utils/ReplaceEmptyStringsOnNull";
import Box from "@mui/material/Box";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import ModalPatterns from "../../../components/UI/modal/ModalPatterns";
import PatternsController from "../../../API/organization/PatternsController";

const PatternsTable = ({
                           moduleId,
                           moduleName,
                           data,
                           setData,
                           handleModalAlert,
                           tableOptions,
                           tableOptionsHandle,
                           globalFilter,
                           handleSearchQuery,
                           filteredData,
                           columnsFilter,
                       }) => {
    const initValue = {
        "name": "",
        "patternL": "",
        "patternW": ""
    }

    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(initValue);
    const [loading, setLoading] = useState(false)
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }

    const handleClose = () => {
        setModal(false)
        setCurrentEditRowData(initValue)
    }

    const handleUpdate = (value, submit) => {
        setLoading(true)
        const {id, ...newValue} = value
        PatternsController.update(replaceEmptyStringsOnNull(newValue), moduleId, id)
            .then(function (response) {
                const newData = data.map(el => el.id === response.data.id ? response.data : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                submit()
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleSubmit = (value, submit) => {
        setLoading(true)
        PatternsController.save(moduleId, replaceEmptyStringsOnNull(value))
            .then(function (response) {
                const newData = [...data, response.data]
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                submit()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleAdd = () => {
        setModal(true)
    }
    const handleEdit = (row) => {
        setCurrentEditRowData(row);
        setModal(true)
    };
    const handleDelete = (row) => {
        PatternsController.delete(moduleId, row.id).then(function () {
            const newData = data.filter(el => el.id !== row.id)
            setData(newData)
            handleSearchQuery(globalFilter, newData)
            handleModalAlert("Данные удалены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'name', minSize: 300,
                Cell: ({cell, row}) => (
                    <li key={cell.getValue()}>
                        <Link
                            to={'/organization/module/' + moduleId + '/' + moduleName + '/patterns/' + row.original.id + "/" + row.original.name}>{row.original.name}</Link>
                    </li>
                ),
            },
            {
                header: 'Паттерн длины', accessorKey: 'patternL', minSize: 300,
            },
            {
                header: 'Паттерн ширины', accessorKey: 'patternW', minSize: 300,
            },
        ]

        return baseColumns;

    }, [data, filteredData]);

    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEdit},
        {type: "delete", text: "Удалить", handler: handleDelete},
    ]

    return (<Box sx={{width: '1100px'}}>
        <Box
            sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
        >
            <ButtonCreate
                text={"Добавить"}
                width={130}
                onClick={handleAdd}
            />
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: '1100px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={filteredData}
            rowHeight={13}
            columnSpacing={1}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            onGlobalFilterChange={(value) => {
                handleSearchQuery(value, data, null)
            }}
            onColumnFiltersChange={(updater) => {
                handleSearchQuery(updater(columnsFilter), data, null, true)
            }}
            onShowColumnFiltersChange={handleShowColumnFilters}
            state={{
                showColumnFilters: showColumnFilters,
                columnFilters: columnsFilter,
                globalFilter: globalFilter,
                showGlobalFilter: true,
                pagination: tableOptions,
            }}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return (el.type === "edit" || (el.type === "delete" && !row.original.blocked)) && <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        <ModalPatterns
            title={currentEditRowData.id ? "Изменить" : "Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={currentEditRowData.id ? handleUpdate : handleSubmit}
            initValue={currentEditRowData}
            loading={loading}
        />
    </Box>);
}
export default PatternsTable